// import dayjs from "dayjs";

// const rssiHistory = {
//   // tooltip: {
//   //   trigger: "axis",
//   //   axisPointer: {
//   //     type: "shadow",
//   //   },
//   // },
//   tooltip: {
//   trigger: "item",
//    borderColor: "#6F7171",
//   formatter: function (params) {
//     const date = new Date(params.data[0]);
//     const formattedDate = `${(date.getMonth() + 1)
//       .toString()
//       .padStart(2, "0")}-${date.getDate()
//       .toString()
//       .padStart(2, "0")}-${date.getFullYear()} ${date
//       .getHours()
//       .toString()
//       .padStart(2, "0")}:${date.getMinutes()
//       .toString()
//       .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
//     return `${formattedDate}<br />Signal Strength ${params.data[1]}`;
//   },
// },
//   grid: {
//     left: 60,
//     top: 20,
//     right: 60,
//     bottom: 60,
//   },
//   xAxis: [
//     {
//       type: "time",
//       name: "Time",
//       nameGap: 40,
//       nameLocation: "middle",
//       boundaryGap: false,
//       axisPointer: {
//         label: {
//           formatter: function (params) {
//             return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
//           },
//         },
//         handle: {
//           show: false,
//         },
//       },
//       axisLabel: {
//         formatter: function (value) {
//           const date = new Date(value);
//           const formattedDate = `${(date.getMonth() + 1).toString().padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date.getFullYear()}`;

//           return formattedDate;
//         },
//       },
//     },
//   ],
//   yAxis: [
//     {
//       type: "value",
//       name: "Signal Strength (dBm)",
//       // name: "RSSI (dBm)",
//       nameGap: 40,
//       nameRotate: 90,
//       nameLocation: "middle"
//     },
//   ],
//   series: [
//     {
//       name: "RSSI",
//       type: "line",
//       data: [],
//      // symbol: "none",
//       itemStyle: {
//         color: "#FF8027",
//       },
//       lineStyle: {
//         normal: {
//           width: 4,
//           type: "solid",
//         },
//       },
//     },
//   ],
// };

// export default rssiHistory;

import dayjs from "dayjs";
const createrssiHistoryOptions = (val, dataInput = []) => {
  const attrMin = val ? parseFloat(val.min) : 0;
  const attrMax = val ? parseFloat(val.max) : 100;
  const dataZoomConfig =
    Array.isArray(dataInput) && dataInput.length > 0
      ? [
          {
            type: "slider",
            start: 0,
            end: 100,
            show: true,
            showDetail: false,
          },
        ]
      : [];
  const rssiHistory = {
    dataZoom: dataZoomConfig,
    tooltip: {
      trigger: "item",
      borderColor: "#6F7171",
      formatter: function (params) {
        if (params.componentType === "markLine") {
          if (params.value === attrMin) {
            return `Min Alert limit: ${params.value}`;
          } else if (params.value === attrMax) {
            return `Max Alert limit: ${params.value}`;
          }
          return `Alert limit: ${params.value}`;
        }
        const date = new Date(params.data[0]);
        const formattedDate = `${(date.getMonth() + 1)
          .toString()
          .padStart(2, "0")}-${date
          .getDate()
          .toString()
          .padStart(2, "0")}-${date.getFullYear()} ${date
          .getHours()
          .toString()
          .padStart(2, "0")}:${date
          .getMinutes()
          .toString()
          .padStart(2, "0")}:${date.getSeconds().toString().padStart(2, "0")}`;
        return `${formattedDate}<br />Signal Strength ${params.data[1]}`;
      },
    },
    grid: {
      left: 60,
      top: 20,
      right: 60,
      bottom: 100,
    },
    xAxis: [
      {
        type: "time",
        name: "Time",
        nameGap: 40,
        nameLocation: "middle",
        boundaryGap: false,
        axisPointer: {
          label: {
            formatter: function (params) {
              return dayjs(params.value).format("MM-DD-YYYY HH:mm:ss");
            },
          },
          handle: {
            show: false,
          },
        },
        axisLabel: {
          formatter: function (value) {
            return dayjs(value).format("MM/DD/YYYY\nh:mm A");
          },
        },
      },
    ],
    yAxis: [
      {
        type: "value",
        name: "Signal Strength (dBm)",
        // name: "RSSI (dBm)",
        nameGap: 40,
        nameRotate: 90,
        nameLocation: "middle",
        splitLine: {
          show: true,
          lineStyle: {
            color: "#d4d4d4",
            width: 1.5,
            type: "solid",
          },
        },
        //  axisLabel: {
        //   formatter: function(value) {
        //     if (value === attrMin || value === attrMax) {
        //       return `{bg|${value}}`;
        //     }
        //     return value;
        //   },
        //   rich: {
        //     bg: {
        //       backgroundColor: '#FF8027',
        //       color: '#FFF',
        //       padding: [2, 4],
        //       borderRadius: 4
        //     }
        //   }
        // },
      },
    ],
    visualMap: {
      show: false,
      dimension: 1,
      pieces: [
        { gt: attrMin - 1, lte: attrMax, color: "#00B845" },
        { lte: attrMin >= attrMax ? attrMin-1 : attrMin, color: "#00B845" },
        { gt: attrMax, color: "#00B845" },
      ],
    },
    series: [
      {
        name: "RSSI",
        type: "line",
        data: [],
        lineStyle: {
          width: 2,
        },
        symbolSize: 8,
        width: 4,
        itemStyle: {
          color: function (params) {
            const value = params.data[1];
            if (value >= attrMin && value <= attrMax) {
              return "#00B845";
            }
            return "#00B845";
          },
          borderWidth: 1,
          borderColor: "#333",
        },
        emphasis: {
          itemStyle: {
            borderWidth: 2,
            borderColor: "#000",
            symbolSize: 10,
          },
        },
        //  markLine: {
        //   silent: false,
        //   symbol: ['none', 'none'],
        //   lineStyle: {
        //     color: 'orange',
        //     type: 'dotted',
        //     width: 2,
        //     type: [8, 6]
        //   },
        //   emphasis: {
        //     lineStyle: {
        //       width: 1
        //     }
        //   },
        //   data: [
        //     {
        //       yAxis: attrMin,
        //       label: {
        //         show: true,
        //         formatter: attrMin,
        //         position: 'start',
        //         distance: 5,
        //         color: '#FFF',
        //         backgroundColor: '#FF8027',
        //         padding: [2, 4],
        //         borderRadius: 4
        //       }
        //     },
        //     {
        //       yAxis: attrMax,
        //       label: {
        //         show: true,
        //         formatter: attrMax,
        //         position: 'start',
        //         distance: 5,
        //         color: '#FFF',
        //         backgroundColor: '#FF8027',
        //         padding: [2, 4],
        //         borderRadius: 4
        //       }
        //     }
        //   ]
        // },
        markArea: {
          silent: true,
          itemStyle: {
            color: "rgba(255, 235, 224, 0.6)",
            borderColor: "transparent",
          },
          data: [
            [
              {
                yAxis: 0,
              },
              {
                yAxis: attrMin,
              },
            ],
            [
              {
                yAxis: attrMax,
              },
              {
                yAxis: 100,
              },
            ],
          ],
          z: -1,
        },
      },
    ],
  };
  return rssiHistory;
};
export default createrssiHistoryOptions;
